<!--
 * @Author: 范向玲
 * @Date: 2022-12-08 13:48:05
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @LastEditTime: 2024-12-25 15:56:40
 * @Description: 矿业资讯-数据管理
 * @FilePath: \web\src\components\DataManager\MiningInfo\index.vue
-->
<template>
  <div class="mining-info-main">
    <div class="search-container">

      <div class="crud-wrapper" v-if="operationConf.includes(config.getPermissionId())">
        <div class="crud-item" @click="selectEdit()"
          :class="selectedKeys.length === 1 ? 'crud-item-abled' : 'crud-item-disabled'">
          编辑
        </div>
        <div class="crud-item" @click="add()">新增</div>
        <div class="crud-item" @click="selectDel()"
          :class="selectedKeys.length > 0 ? 'crud-item-abled' : 'crud-item-disabled'">
          删除
        </div>
      </div>
    </div>

    <a-table rowKey="id" class="management-table" :dataSource="dataPages" :loading="dataPagesLoading" :columns="columns"
      @change="changePage" :row-selection="rowSelection" :scroll="{ y: '90%' }" :pagination="paginationOption">
      <template #serial="{ index }">{{ index + 1 }}</template>

      <template #primaryCommodity="{ record }">
        <img class="primary-commodity-img" :src="getMineralImage(record)" alt="" srcset="" />
      </template>

      <template #commoditiesList="{ text: commoditiesList }">
        <span>
          <a-tag v-for="(item, index) in commoditiesList ? commoditiesList.split(',') : []" :key="index">{{ item
            }}</a-tag>
        </span>
      </template>

      <template #action="{ record }">
        <section class="action-icons">
          <div class="crud-wrapper" v-if="operationConf.includes(config.getPermissionId())">
            <div class="crud-item" :class="record.shows !== '1' ? 'crud-item-abled' : 'crud-item-disabled'"
              @click="beforeAddScreen(record)">
              页面展示
            </div>
            <div class="crud-item" :class="record.shows === '1' ? 'crud-item-abled' : 'crud-item-disabled'"
              @click="beforeCancelScreen(record)">
              取消展示
            </div>
          </div>
          <i v-for="(item, index) in tableOperationList" :key="index" v-bind="item.option" @click="item.click(record)">
          </i>
        </section>
      </template>
    </a-table>

    <Modal :option="confirmModalConf" @confirm="confirm" @close="close">
      <template v-slot:main>
        <template v-if="confirmModalConf.isAdd">
          <AddData :option="addOption" />
        </template>
      </template>
    </Modal>
    <!-- / 操作弹出框 -->
  </div>
</template>

<script setup>
import { ref, reactive, computed, toRefs, watch, onMounted, onBeforeMount, } from 'vue';
import { useStore, } from 'vuex';
import { message, } from 'ant-design-vue';
import Modal from '@/components/lib/Modal/modal1.vue';
import config from '@/config/config';
import { tableConfig, } from './tableConfig.js';
import { infoSaveApi, removeInfoApi, infoUpdateApi, getInfoDetailApi, } from '@/api/bigScreen/miningInfo';
import { GET_MINING_INFO_PAGE, } from '@/store/modules/actions/screenDataManager';
import AddData from './AddData.vue';
import moment from 'moment';

const columns = tableConfig;

const { state, dispatch: storeDispatch, commit: storeCommit, } = useStore();
// state
const miningInfoState = computed(() => state.miningInfo);
const { requestParams, dataPages, totalCount, dataPagesLoading, orenodeResultVisible, activeKey, } = toRefs(
  miningInfoState.value
);
// 重写commit
const commit = (space, methods, params) => storeCommit(`${space || 'miningInfo'}/${methods}`, params);
// 重写dispatch
const dispatch = (space, methods, params) => storeDispatch(`${space || 'miningInfo'}/${methods}`, params);

const selectedKeys = ref([]); // 表格选中id

const paginationOption = computed(() => ({
  total: totalCount.value,
  pageSize: requestParams.value.size,
  current: requestParams.value.page,
  showSizeChanger: true,
  showQuickJumper: true,
  pageSizeOptions: ['6', '10', '20', '30', '40', '50',],
}));

// 确认弹窗 公用
const confirmModalConf = reactive({
  loading: false,
  visible: false,
  title: '',
  confirm: null,
  callback: null,
  isAdd: false,
  width: '5.4rem',
});

// 新增编辑弹窗 公用
const modalOption = reactive({
  visible: false,
  loading: false,
  datalist: {},
  modalType: 'default',
});
// 新增表单配置
const addOption = ref([
  {
    label: '资讯名称',
    dataIndex: 'name',
    type: 'input',
  },
  {
    label: '资讯时间',
    dataIndex: 'date',
    type: 'datePicker',
  },
  {
    label: '资讯地址',
    dataIndex: 'url',
    type: 'input',
  },
  {
    label: '信息来源',
    dataIndex: 'source',
    type: 'input',
  },
]);

/**
 * @description 查询
 */
const searchHandle = () => {
  dispatch(null, GET_MINING_INFO_PAGE);
};

/* 取消数据展示 */
const cancelScreen = (record) => {
  record.shows = '0';
  infoUpdateApi(record).then(res => {
    confirmModalConf.visible = false;
    searchHandle();
  });
};
const beforeCancelScreen = (record) => {
  confirmModalConf.title = '确认取消数据至页面展示？';
  confirmModalConf.callback = () => cancelScreen(record);
  confirmModalConf.visible = true;
};

// 添加至大屏数据展示
const addScreen = (record) => {
  record.shows = '1';
  infoUpdateApi(record).then(res => {
    confirmModalConf.visible = false;
    searchHandle();
  });
};
// 添加至大屏数据展示前
const beforeAddScreen = (record) => {
  confirmModalConf.title = '确认添加数据至页面展示？';
  confirmModalConf.callback = () => addScreen(record);
  confirmModalConf.visible = true;
};
const addData = () => {
  const params = {};

  addOption.value.map(item => {
    if (item.type === 'datePicker') {
      item.date = moment(item.date).format('YYYY-MM-DD');
    }
    params[item.dataIndex] = item[item.dataIndex];
  });

  infoSaveApi(params).then(res => {
    confirmModalConf.visible = false;
    confirmModalConf.isAdd = false;
    searchHandle();
  });
};
// 新增数据
const add = () => {
  confirmModalConf.title = '新增数据';
  confirmModalConf.isAdd = true;
  confirmModalConf.callback = () => addData();
  confirmModalConf.visible = true;
};

const upDateData = (record) => {
  const params = {
    id: selectedKeys.value.at(-1),
    shows: record.shows,
  };

  addOption.value.map(item => {
    if (item.type === 'datePicker') {
      item.date = moment(item.date).format('YYYY-MM-DD');
    }
    params[item.dataIndex] = item[item.dataIndex];
  });

  infoUpdateApi(params).then(res => {
    confirmModalConf.visible = false;
    confirmModalConf.isAdd = false;
    searchHandle();
  });
};
const selectEdit = () => {
  getInfoDetailApi(selectedKeys.value.at(-1)).then(res => {
    if (res.code === 200 && res.status) {
      addOption.value.map(item => {
        item[item.dataIndex] = res.data[item.dataIndex];
      });
      confirmModalConf.title = '编辑数据';
      confirmModalConf.isAdd = true;
      confirmModalConf.callback = () => upDateData(res.data);
      confirmModalConf.visible = true;
    }
  });
};

/**
 * @description 检索重置事件
 */
const resetSearch = () => {

};

/**
 * @description 检索查询事件
 */
const submitSearch = () => { };

/**
 * @description 表格选中事件
 */
const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {
    selectedKeys.value = selectedRowKeys;
  },
};


// -------------------- 删除
// 开始删除
const delInfo = (ids) => {
  removeInfoApi(ids).then(res => {
    confirmModalConf.visible = false;
    searchHandle();
  });
};
// 单行数据删除之前
const beforeDel = (ids) => {
  confirmModalConf.title = '确认删除项目？';
  confirmModalConf.callback = () => delInfo(ids);
  confirmModalConf.visible = true;
};
// 单行删除
const delRecord = (record) => {
  const { id, } = record;

  beforeDel([id,]);
};
/**
 * @description 勾选删除
 */
const selectDel = () => {
  const ids = selectedKeys.value;

  beforeDel(ids);
};
/**
 * @description 页码change事件
 */
const changePage = (page) => {
  commit(null, 'setRequestParams', { page: page.current, size: page.pageSize, });
  searchHandle();
};

/**
 * @description 关闭通用弹窗
 */
const close = () => {
  confirmModalConf.visible = false;
  confirmModalConf.isAdd = false;
  confirmModalConf.width = '5.4rem';
};

/**
 * @description 确认通用弹窗
 */
const confirm = () => {
  confirmModalConf.callback();
};


const tableOperationList = ref([]);
// 新增 删除的权限控制
const operationConf = [1, 2,];

// 操作的权限
const tableOperationListConf = [
  {
    option: {
      style: 'color: rgb(255, 200, 120)',
      class: 'iconfont icon-shanchu',
      title: '删除',
    },
    click: delRecord,
    operation: [1,],
  },
];

onBeforeMount(() => {
  // window.open('/pdf/024434.pdf');
  tableOperationList.value = tableOperationListConf.filter((i) => i.operation.includes(config.getPermissionId()));
  searchHandle();
});
</script>

<style lang="scss">
.mining-info-main {
  height: 100%;
  background: rgba(179, 150, 92, 0.05);

  /* 检索条件 */
  .search-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-left: .1rem;
    height: 0.5rem;
    margin-bottom: 0.1rem;

    .search {
      display: flex;

      .search-item {
        width: 2.2rem;
        height: 0.34rem;
        margin-right: 0.05rem;
        display: flex;

        .search-item-text {
          color: #fff;
          width: 1.1rem;
          text-align: right;
          height: 0.34rem;
          line-height: 0.34rem;
        }
      }

      /* 重置、查询操作 */
      .btn-wrapper {
        height: 0.32rem;
        line-height: 0.32rem;
        margin-left: 0.2rem;
        color: #ffffff;
        display: flex;
        padding: 0;

        .btn-item {
          width: 0.9rem;
          text-align: center;
          cursor: pointer;

          &:active {
            opacity: 0.8;
          }
        }

        .reset-btn {
          // background-color: #535962;
          background-image: url(~@/static/images/dataManagement/reset_btn.png);
          background-size: 100% 100%;
        }

        .search-btn {
          margin-left: 0.05rem;
          // background-color: #efb227;
          background-image: url(~@/static/images/dataManagement/submit_btn.png);
          background-size: 100% 100%;
        }
      }

      /* 输入框 */
      .ant-input {
        color: white;
        background-color: rgba(91, 76, 39, 0.4);
        font-size: 0.14rem;
        font-family: Microsoft YaHei;
        border: transparent;
      }

      .ant-input-suffix {
        width: 0.12rem;
        height: 0.12rem;
        margin-top: .02rem;
      }

      /** 下拉框 */
      .ant-select {
        width: 100%;
        height: 100%;

        .ant-select-selector {
          height: 100%;
        }

        .ant-select-arrow {
          color: #fff;
        }

        .ant-select-selection-item {
          line-height: .34rem;
        }

        // 背景
        &:not(.ant-select-customize-input) .ant-select-selector {
          background-color: rgba(91, 76, 39, 0.4);
          border: none;
          color: #fff;
        }

        /* 描述 */
        .ant-select-selection-placeholder {
          line-height: .34rem;
          color: #fff;
        }
      }
    }

    /* 增删改导按钮 */
    .crud-wrapper {
      display: flex;
      height: 0.51rem;
      padding: 0.13rem 0.1rem;

      .crud-item {
        margin-right: 0.04rem;
        width: 0.5rem;
        line-height: .25rem;
        color: #fff;
        // background-color: #efb227;
        background-image: url(~@/static/images/dataManagement/curd_btn.png);
        background-size: 100% 100%;
        text-align: center;
      }

      .crud-item:hover {
        cursor: pointer;
      }

      .crud-item-disabled {
        pointer-events: none;
        color: rgba(255, 255, 255, 0.6);
        // background-color: rgba(239, 178, 39, 0.6);
        opacity: 0.8;
      }

      .crud-item-disabled:hover {
        cursor: no-drop;
      }
    }
  }

  /* 矿种图标 */
  .minerals-img {
    width: 0.6rem;
    height: 0.3rem;
  }

  /* 表格样式 */
  .management-table {
    height: calc(100% - 0.5rem);

    .ant-spin-container {
      display: flex;
      flex-direction: column;
      align-items: end;
    }

    .ant-spin-nested-loading,
    .ant-spin-container,
    .ant-table-content {
      height: 100%;
    }

    .ant-table {
      height: calc(100% - .70rem);
      background: none;
      padding-left: 0.1rem;

      .ant-table-scroll {
        height: 100%;
        overflow: visible;
        overflow-x: visible;

        .ant-table-header {
          overflow: visible !important;
          margin-bottom: 0 !important;
        }
      }

      .ant-table-header {
        background: none;
      }

      .ant-table-body {
        overflow-x: hidden !important;
        overflow-y: auto !important;
        background: none;
      }

      /* 矿种 */
      .primary-commodity-img {
        width: 0.8rem;
        height: 0.6rem;
      }

      /* 图标 */
      .action-icons {
        display: flex;

        i {
          font-size: 0.22rem;
          margin-right: 0.04rem;
          cursor: pointer;
        }

        .crud-wrapper {
          display: flex;
          height: 0.25rem;
          padding: 0 0.1rem;
          margin-top: 0.05rem;

          .crud-item {
            margin-right: 0.04rem;
            width: 0.7rem;
            line-height: .25rem;
            color: #fff;
            // background-color: #efb227;
            background-image: url(~@/static/images/dataManagement/curd_btn.png);
            background-size: 100% 100%;
            text-align: center;
          }

          .crud-item:hover {
            cursor: pointer;
          }

          .crud-item-disabled {
            pointer-events: none;
            color: rgba(255, 255, 255, 0.6);
            // background-color: rgba(239, 178, 39, 0.6);
            opacity: 0.8;
          }

          .crud-item-disabled:hover {
            cursor: no-drop;
          }
        }
      }

      .ant-table-thead {
        border: .01rem solid #4d3f1c;
        border-radius: .10rem .10rem 0rem 0rem;
        background: none;
      }

      .ant-table-thead>tr>th {
        color: #dccdab;
        background: rgba(179, 150, 92, 0.2);
        border: none;
      }

      .ant-table-tbody>tr>td {
        background-color: transparent;
        color: #fff;
        border-bottom: .01rem solid rgba(179, 150, 92, 1);
        vertical-align: middle;
      }

      .ant-table-placeholder {
        height: 100%;
        background-color: rgba(77, 63, 28, 1);
        border-top: rgba(179, 150, 92, 1);
        border-bottom: rgba(179, 150, 92, 1);
      }

      .ant-empty-normal {
        color: rgba(179, 150, 92, 1);
      }

      // 暂无数据填充样式
      // .ant-empty-img-simple-path {
      //   fill: rgba(77, 63, 28, 1);
      // }
      // .ant-empty-img-simple-ellipse {
      //   fill: rgba(77, 63, 28, 1);
      // }
      .ant-table-thead>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-tbody>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-thead>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
        background-color: rgba(179, 150, 92, 0.6);
      }

      .ant-table-thead>tr:hover.ant-table-row-selected>td,
      .ant-table-tbody>tr:hover.ant-table-row-selected>td {
        background-color: rgba(179, 150, 92, 0.6);
      }

      .ant-table-tbody>tr.ant-table-row-selected td {
        background-color: rgba(77, 63, 28, 1);
        color: #fff;
      }
    }
  }
}
</style>
